import { isScreenshotMessage } from 'domains/notification/types';
import { useState } from 'react';
import {
  IUseScreenshotNotificationProps,
  IUseScreenshotNotificationData,
} from '../types';

export const useScreenshotNotification = ({
  message,
  handleMarkAsRead,
}: IUseScreenshotNotificationProps): IUseScreenshotNotificationData => {
  const { creative_xxhash, creative_title, screenshot_url, campaign_xxhash, creative_internal_id } =
    isScreenshotMessage(message) ? message : {};
  const [loadedImg, setLoadedImg] = useState(false);

  const saveScreenHandler = () => {
    if (!screenshot_url) return;
    const imageUrl = screenshot_url;
    const fileName = `${screenshot_url}.png`;

    fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        handleMarkAsRead();
      });
  };
  return {
    creative_internal_id,
    creative_title,
    creative_xxhash,
    screenshot_url,
    campaign_xxhash,
    loadedImg,
    setLoadedImg,
    saveScreenHandler,
  };
};
